import { render, staticRenderFns } from "./FeePolicyIframe.vue?vue&type=template&id=5b560002&"
import script from "./FeePolicyIframe.vue?vue&type=script&lang=ts&"
export * from "./FeePolicyIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports